import { createFileRoute } from "@tanstack/react-router";
import AdminPartsCustomerEdit from "@/pages/admin/AdminPartsCustomerEdit";

export const Route = createFileRoute("/_adminLayout/admin/parts/customers/$id")({
  component: AdminPartsCustomerEdit,
});
